// MEO Phase 1 (2026-04-30〜): Omikuji 階層 / モチーフ の表示ラベル定義。
//
// CMS dashboard / 文言プール管理 等の複数 page で同じ enum を表示するため
// 単一情報源として集約。spec: design/meo-landmark-ads-spec.md §UX/UI

export const FORTUNE_LABEL: Record<number, string> = {
    1: '大吉',
    2: '中吉',
    3: '小吉',
    4: '末吉',
    5: '凶'
};

export const MOTIF_LABEL: Record<string, string> = {
    whaleshark: 'ジンベエザメ',
    turtle: 'アオウミガメ',
    yambaru_kuina: 'ヤンバルクイナ',
    akashobin: 'アカショウビン',
    mangrove: '月夜のマングローブ'
};
